import React from "react";

const ProductItem = ({ product }) => {
  const { image } = product;

  return (
    <div className="brand-logo">
      <div className="brand-logo-inner">
        <img
          style={{ width: "100%", height: "100%" }}
          className="img-fluid"
          src={image}
          alt="Clients"
        />
      </div>
    </div>
  );
};

export default ProductItem;



// WEBPACK FOOTER //
// ./components/product/ProductItem.js